import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { X, Send, Loader2 } from 'lucide-react';

interface EnviarProtocoloModalProps {
  ugNome: string;
  onClose: () => void;
  onConfirmar: (observacao: string, emailCopia: string) => Promise<void>;
}

const EnviarProtocoloModal: React.FC<EnviarProtocoloModalProps> = ({ ugNome, onClose, onConfirmar }) => {
  const [observacao, setObservacao] = useState('');
  const [emailCopia, setEmailCopia] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleConfirmar = async () => {
    setEnviando(true);
    try {
      await onConfirmar(observacao.trim(), emailCopia.trim());
    } finally {
      setEnviando(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-gray-700">
          <h2 className="text-lg font-bold text-gray-900 dark:text-white font-poppins flex items-center gap-2">
            <Send size={20} className="text-primary" /> Enviar Planilha — {ugNome}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <X size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Observação (opcional)
            </label>
            <textarea
              value={observacao}
              onChange={e => setObservacao(e.target.value)}
              rows={3}
              placeholder="Vai no corpo do e-mail junto com o protocolo..."
              className="w-full bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              E-mail em Cópia (opcional)
            </label>
            <input
              type="email"
              value={emailCopia}
              onChange={e => setEmailCopia(e.target.value)}
              placeholder="alguem@vigorenergy.com.br"
              className="w-full bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Além dos e-mails já configurados (distribuidora / e-mail principal), este recebe cópia só deste envio.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-3 p-6 border-t border-gray-100 dark:border-gray-700">
          <button
            onClick={onClose}
            disabled={enviando}
            className="px-4 py-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-60"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmar}
            disabled={enviando}
            className="px-4 py-2 rounded-lg bg-primary text-white font-medium hover:opacity-90 disabled:opacity-60 flex items-center gap-2"
          >
            {enviando ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
            Enviar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EnviarProtocoloModal;
